import { ReactElement } from 'react';
import styles from './limited-view-banner.module.scss';
import { UIIcon, UIText } from '@/ui';
import { useCompaniesTranslation } from '../hooks';

// Owners and admins see everything a page has to offer. Everyone else gets a
// server-filtered list with most actions withheld, so tell them rather than
// leaving them to wonder what happened to the rest of it. Callers decide when
// to show this — the permission that limits the view differs per page.
export function LimitedViewBanner(): ReactElement {
    const { t } = useCompaniesTranslation();

    return (
        <div className={styles.container}>
            <UIIcon name="info" size={18} className={styles.icon} />
            <UIText>{t('components.limited_view_banner.message')}</UIText>
        </div>
    );
}
